/**
 * お気に入り（Wishlist Club）の全ページ共通の調整。layout/theme.liquid から全ページで読み込む。
 *
 * 1. ヘッダーのハート
 *    アプリ（wishlistclub-autosetup.js）はハート（a.wc_wishlistIcon、件数付き）をカートの枠の中に入れ、
 *    リンク先を /apps/wishlist にする。そのままだとスマホで件数がカートに重なり、
 *    リンク先もお気に入りページ（templates/page.wishlist.json）ではない。
 *    sections/header.liquid の [data-rw-wishlist-slot]（カートの左）に移し、リンク先と読み上げ名を直す。
 * 2. 読み上げ用のラベル（aria-label）
 *    アプリはボタンの aria-label を英語で固定している。日本語のページでは日本語にする
 *    （英語のページは英語のままでよいので何もしない）。
 *
 * アプリは画面を後から描くので、DOM の変化を監視して追加された部分も直す。
 */
(function () {
  var isJa = (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;

  // アプリの英語の aria-label → 日本語（完全一致）
  var ARIA_JA = {
    'Add To Wishlist': 'お気に入りに追加',
    'Remove Wishlist': 'お気に入りから外す',
    'add to cart': 'カートに入れる',
    'Add to cart': 'カートに入れる'
  };

  function fixHeaderIcon() {
    var slot = document.querySelector('[data-rw-wishlist-slot]');
    var icon = document.querySelector('a.wc_wishlistIcon');
    if (!slot || !icon) return;
    if (icon.parentElement !== slot) {
      slot.appendChild(icon);
      slot.hidden = false;
    }
    var url = slot.getAttribute('data-wishlist-url');
    if (url && icon.getAttribute('href') !== url) icon.setAttribute('href', url);
    var label = isJa ? 'お気に入り' : 'Wishlist';
    if (icon.getAttribute('aria-label') !== label) icon.setAttribute('aria-label', label);
  }

  function fixAriaLabels() {
    if (!isJa) return;
    Array.prototype.forEach.call(document.querySelectorAll('.wc_wishlistBlock[aria-label], .wcButton[aria-label], .wcProductTrigger[aria-label]'), function (el) {
      var value = el.getAttribute('aria-label');
      if (Object.prototype.hasOwnProperty.call(ARIA_JA, value)) {
        el.setAttribute('aria-label', ARIA_JA[value]);
      } else if (/^Remove the wishlist item /.test(value)) {
        // 「Remove the wishlist item '商品名'」→「商品名をお気に入りから外す」
        var name = value.replace(/^Remove the wishlist item '?/, '').replace(/'$/, '');
        el.setAttribute('aria-label', name + 'をお気に入りから外す');
      }
    });
    // 数量の −／＋ と種類の選択欄にはラベルがないので付ける
    Array.prototype.forEach.call(document.querySelectorAll('.wcQuantityBox'), function (box) {
      var buttons = box.querySelectorAll('.wcQuantityButton');
      if (buttons[0] && !buttons[0].hasAttribute('aria-label')) buttons[0].setAttribute('aria-label', '数量を減らす');
      if (buttons[1] && !buttons[1].hasAttribute('aria-label')) buttons[1].setAttribute('aria-label', '数量を増やす');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.wcPcSelector:not([aria-label])'), function (select) {
      select.setAttribute('aria-label', '種類を選ぶ');
    });
  }

  function run() {
    fixHeaderIcon();
    fixAriaLabels();
  }

  function start() {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
